export default "__VITE_ASSET__DsRTtlQg__"